import React, { Component } from 'react'
import {Link} from 'react-router'
import TypeWriter from 'react-typewriter'
import {MdError} from '../ReactIcons/icons'

import './Layout/InfoNotification.css'

class InfoNotification extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isShowTextAlert: false,
      isShowCloseAlert: false,
      isShowBox: true
    }
  }

  componentDidMount () {
    setTimeout(() => { this.setState({isShowTextAlert: true}) }, 200)
    setTimeout(() => { this.setState({isShowCloseAlert: true}) }, 1300)
  }

  render () {
    const { isShowCloseAlert, isShowTextAlert, isShowBox } = this.state
    const { message, url } = this.props

    return (
      isShowBox && <div className="info-notification-container">
        <div className="info-notification-box">
          {isShowCloseAlert && <div className="close" onClick={(e) => { this.setState({isShowBox: false}) }}>x</div>}
          <Link to={url}>
            <MdError className="icon" />
            <span className="text">{isShowTextAlert && <TypeWriter typing={1} minDelay={50}>{message}</TypeWriter>}</span>
          </Link>
        </div>
      </div>
    )
  }
}

export default InfoNotification



// WEBPACK FOOTER //
// ./src/components/Common/InfoNotification/InfoNotification.js